import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class PartnerOrderService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getPartnerOrders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPartnerOrder/GetPartnerOrders', data, messageService);
    }

    public getPartnerLocations(messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPartnerOrder/GetPartnerLocations', null, messageService);
    }

    public getOrderItems(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/GetOrderItems', data, messageService);
    }

    public getPayments(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/GetPayments', data, messageService);
    }

    public getMessages(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/GetMessages', data, messageService);
    }

    public getOrderHistory(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/GetOrderHistory', data, messageService);
    }
}
